import { SidebarPresenter } from 'presenters'
import { DEFAULT_SIDEBAR_PANEL, SIDEBAR_LINKS } from 'enums/sidebar'
import { Query_Root } from 'shared/presenters/graphqlTypes'

export type SidebarJSON = Pick<Query_Root, 'Business_InstructorSidebar'>

const formatSidebarNavLinks = (sidebarJSON?: SidebarJSON) => {
  const navLinks =
    sidebarJSON?.Business_InstructorSidebar &&
    new SidebarPresenter(sidebarJSON?.Business_InstructorSidebar).collection()

  const determineIsDefaultMenu = (name: string) => {
    return SIDEBAR_LINKS?.some(item => {
      return item === name.replace(' ', '-').toLocaleLowerCase()
    })
  }

  /**
   * The instructor panel demands a different configuration because it is manipulated
   * via the instructor's button located outside the nav.
   *
   * The main difference with the instructor configuration is how it interacts
   * with the other links. We gain more simplicity and flexibility by moving it to another SidebarNavList.
   */
  const defaultMenu = {
    name: DEFAULT_SIDEBAR_PANEL,
    collection: navLinks?.filter(item => determineIsDefaultMenu(item.name))
  }

  const instructorLinks = navLinks?.filter(
    item => !determineIsDefaultMenu(item.name)
  )?.[0]

  const instructorMenu = instructorLinks
    ? {
        name: instructorLinks.name,
        collection: instructorLinks.collection
      }
    : undefined

  return { defaultMenu, instructorMenu }
}

export default formatSidebarNavLinks
